import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UserPreferencesService
{
    public constructor()
    {
    }

    // TODO: Need to make use of the storage service
    public getUserPreferences(): any
    {
        const pref = JSON.parse(localStorage.getItem('userPreferences'));

        return pref ? pref : null;
    }
}
